<div class="custom-box">
    <div class="custom-text">
        <div>
            <h2 [innerHTML]="headlineHtml"></h2>
            <p [innerHTML]="descriptionHtml"></p>
        </div>

        <ng-content></ng-content>

        <a [routerLink]="link ? [link] : null" (click)="onButtonClick()"
           class="btn btn-primary small font-bold">
            {{ buttonText }}
        </a>
    </div>
</div>
